import { useMutation, useQuery } from "@tanstack/react-query";
import axiosInstance from "./axios";
import { BranchSchemaT } from "../types/schema/branchSchema";
import { Branch, BranchSearchParams, Counter } from "../types/branchType";
import { PaginationResponse } from "../types/commonTypes";

export const useAddBranch = () => {
  return useMutation({
    mutationKey: ['useAddBranch'],
    mutationFn: async (postData: BranchSchemaT) => {
      const { data } = await axiosInstance.post('/branch', postData);
      return data;
    },
  });
};

export const useEditBranch = () => {
  return useMutation({
    mutationKey: ['useEditBranch'],
    mutationFn: async ({ branchId, postData }: { branchId: number; postData: BranchSchemaT }) => {
      const { data } = await axiosInstance.put(`/branch/${branchId}`, postData);
      return data;
    },
  });
};

export const useGetAllBranches = ({
  params,
}: {
  params: BranchSearchParams;
}) => {
  return useQuery({
    queryKey: ['useGetAllBranches', params],
    queryFn: async () => {
      const { data } = await axiosInstance.get('/branch/get-all', {
        params,
      });
      return data as PaginationResponse<Branch>;
    },
    enabled: !!params,
  });
};

export const useGetCounters = ({
  params,
}: {
  params: BranchSearchParams & { branchId: string };
}) => {
  return useQuery({
    queryKey: ['useGetCounters', params],
    queryFn: async () => {
      const { data } = await axiosInstance.get('/counter/get-all', {
        params,
      });
      return data as PaginationResponse<Counter>;
    },
    enabled: !!params?.branchId,
  });
};

export const useAssignStaffToBranch = () => {
  return useMutation({
    mutationKey: ['useAssignStaffToBranch'],
    mutationFn: async ({
      branchId,
      staffId,
      counterId,
    }: {
      branchId: number;
      staffId: number;
      counterId: number;
    }) => {
      const { data } = await axiosInstance.post('/branch/assign-staff', {
        branchId,
        staffId,
        counterId,
      });
      return data;
    },
  });
};
